import React, { ChangeEvent, useEffect, useState } from 'react'
import InputMask from 'react-input-mask'
import { Autocomplete, Checkbox, Input, Radio } from '../../ui-components'
import {useAppDispatch, useAppSelector} from "../../core/hooks";
import {handleFormChange, formFields} from './customer-slice';
import '../../assets/styles/default-form.scss'
import {AttachIcon} from "../../assets";
import {prepareFileUpload} from "../../services/utils";
import styles from './customer.module.scss'
import {CITIES_UPDATE} from "../../services/constants";

const CustomerForm = ({customer}) => {
  const {form, validationFields} = useAppSelector(state => state.customer)
  const [city, setCity] = useState<string>('')
  const dispatch = useAppDispatch()
  useEffect(()=>{
    if(customer){
      for(const prop in customer){
        if(formFields.includes(prop)){
          if (prop === 'city') {
            for (const region of CITIES_UPDATE) {
              if (region.value === customer.city) {
                setCity(region.value)
              }
            }
          }
          dispatch(handleFormChange({key: prop, value:customer[prop]}))
        }
      }
    }
  }, [customer])

  // handle input change event
  const handleInputChange = (event: ChangeEvent) => {
    const element = event.target as HTMLInputElement
    let value = element.value.replace(/^\+\d{1,3}\s?/, "")
    value = value.replace(/[\(\)\-\s]/g, "")
    dispatch(handleFormChange({key: element.name, value}))
  }

  const selectCity = (el) => {
    setCity(el.value)
    dispatch(handleFormChange({key: 'city', value: el.value }))
  }

  return (
    <div id={styles.customerForm} className="overflow-scroll">
      <div className="temp-03-form">
        <div className={'mb-40'}>
          <Input name='name'
                 error={!validationFields.name}
                 onChange={handleInputChange}
                 value={form.name} label="Имя"/>
        </div>
        <div className={'wrapper'}>
          <InputMask mask="+7 (999) 999-99-99"
                     maskChar=" "
                     formatChars={{
                       "9": "[0-9]"
                     }}
                    permanents={[0,1,2]}
                     className={styles.input}
                     name='primary_phone'
                     error={!validationFields.primary_phone}
                     onChange={(e) => e && handleInputChange(e)}
                     value={form.primary_phone} label="Телефон">
            {(inputProps) => <Input {...inputProps} />}
          </InputMask>
          <Input name='email'
                 error={!validationFields.email}
                 onChange={handleInputChange}
                 value={form.email} label="Почта"/>
          <Input name='address'
                 error={!validationFields.address}
                 onChange={handleInputChange}
                 value={form.address} label="Адрес"/>
        </div>
        <div className="wrapper">
          <Autocomplete className={styles.search}
                        options={CITIES_UPDATE}
                        isClearable={false}
                        value={city}
                        label={'Город'}
                        onChange={(data) => selectCity(data)}
                        optionLabel={'value'}
                        optionValue={'value'}/>
        </div>
      </div>
    </div>
  )
}

export default CustomerForm
